import "./style/style";
import * as React from "react";
import {render} from "react-dom";
import {setupLogging} from "./console";
import {ensureReactRoot} from "@variocube/cube-ui";
import {AppHost} from "./AppHost";
import {getController} from "./controller";
import {getUrlParam} from "./urlParams";
import {parseBoolean} from "@variocube/app-common";
import {logger} from "./logger";

//
// Setup logging
//
setupLogging();


// Specifies whether the app host runs on the secondary side of an installation
// This should later be used to transparently use the secondaryLock whenever
// a box is opened
const secondary = parseBoolean(getUrlParam("secondary")) ?? false;

logger.info("secondary", secondary);

//
// Render AppHost
//
render((
    <AppHost
        controller={getController()}
        secondary={secondary}
    />
), ensureReactRoot('app-host-root'));
